import styled from 'styled-components';

import { colorsPalettes } from '@similarweb/styles';

export const StyledCrmExportButtonLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${colorsPalettes.carbon[500]};
`;
